import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=0a42b4bb&scoped=true&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"
import style0 from "./Menus.vue?vue&type=style&index=0&id=0a42b4bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42b4bb",
  null
  
)

export default component.exports